import React, { useEffect, useState } from 'react';
import { useStyles } from './styles';
import { Box, Typography } from '@mui/material';
import OpeningHourEnableButton from '../OpeningHourEnableButton/OpeningHourEnableButton';
import CustomTimePicker from '../../../../components/TimePicker/TimePicker';
import { Control, FieldValues } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { LANG_TEXT } from '../../../../constants/language';

function Card<TFieldValues extends FieldValues = FieldValues>({
  day_of_week,
  control,
  currentSetting,
  formData,
  setFormData,
  setErrorState,
  errors,
}: {
  day_of_week: string;
  control: Control<TFieldValues>;
  currentSetting: any;
  formData: any;
  setFormData: any;
  setErrorState: any;
  errors: { [key: string]: boolean };
}) {
  const [enabled, setEnabled] = useState(currentSetting.opening_schedule[day_of_week].enabled || false);
  const classes = useStyles();
  const { t } = useTranslation();

  useEffect(() => {
    setEnabled((currentSetting as any).opening_schedule[day_of_week].enabled || false);
  }, [currentSetting]);

  const handleEnabledChange = (value: boolean) => {
    setEnabled(value);
    handleDataChange(day_of_week, { enabled: value });
  };

  const handleDataChange = (dayOfWeek: any, data: any) => {
    if (data.utc_start_time) {
      if (
        isNaN(new Date(data.utc_start_time).getTime()) ||
        (formData[dayOfWeek] && formData[dayOfWeek].utc_end_time && formData[dayOfWeek].utc_end_time < data.utc_start_time)
      ) {
        return setErrorState(dayOfWeek, true);
      }
    } else if (data.utc_end_time) {
      if (
        isNaN(new Date(data.utc_end_time).getTime()) ||
        (formData[dayOfWeek] && formData[dayOfWeek].utc_start_time && data.utc_end_time < formData[dayOfWeek].utc_start_time)
      ) {
        return setErrorState(dayOfWeek, true);
      }
    }

    setErrorState(dayOfWeek, false);
    setFormData((prevData: any) => ({
      ...prevData,
      [dayOfWeek]: {
        ...prevData[dayOfWeek],
        ...data,
      },
    }));
  };

  return (
    <Box className={classes.BoxCard}>
      <OpeningHourEnableButton button_text={day_of_week} value={enabled} handleEnabledChange={handleEnabledChange} />
      <CustomTimePicker
        title={`${t(LANG_TEXT.START_TIME)}:`}
        field="utc_start_time"
        control={control}
        enabled={enabled}
        day_of_week={day_of_week}
        onDataChange={handleDataChange}
        defaultValue={currentSetting.opening_schedule[day_of_week].utc_start_time}
      />
      <CustomTimePicker
        title={`${t(LANG_TEXT.END_TIME)}:`}
        field="utc_end_time"
        control={control}
        enabled={enabled}
        day_of_week={day_of_week}
        onDataChange={handleDataChange}
        defaultValue={currentSetting.opening_schedule[day_of_week].utc_end_time}
      />
      {errors[day_of_week] && (
        <Typography color={'var(--Error-700, #B42318)'} fontSize={16} fontWeight={600} lineHeight={'24px'} textAlign={'center'}>
          {t(LANG_TEXT.TIME_ERROR)}
        </Typography>
      )}
    </Box>
  );
}

export default Card;
